import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import { base_colorSurface, text_colorTextSecondary } from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  &.LayoutShell {
    height: 100%;
    background-color: ${base_colorSurface};
    display: flex;
    flex-direction: column;
    position: relative;
    transition:
      width 0.3s ease,
      max-width 0.3s ease;
    ${getBreakpointDown(breakpointSizes.XSM)(css`
      width: 100%;
    `)}
    padding: 26px 24px;
    gap: 24px;

    &.sideNavSmall {
      width: 100%;
    }

    & .outerContainer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      min-height: 38px;
      max-height: 38px;
    }

    & .title {
      ${getFontCss(
        32,
        themeConstants.colors.font_primary,
        styleConstants.fontFamilies.medium,
      )};
    }

    & .subtitle {
      ${getFontCss(14, text_colorTextSecondary, styleConstants.fontFamilies.regular)};
      margin-top: 8px;
    }
  }
`
